module.exports = __webpack_public_path__ + "static/media/WebGL.899cbee.mp4";


//////////////////
// WEBPACK FOOTER
// ./public/visualImg/WebGL.mp4
// module id = 5mYq
// module chunks = 0